import { render, staticRenderFns } from "./OverlayLoading.vue?vue&type=template&id=046a5eda"
import script from "./OverlayLoading.vue?vue&type=script&lang=js"
export * from "./OverlayLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports